import React from "react";
import assets from "../../assets";

const isVideoURLPresent = (videoJsOptions) => {
    return (
        videoJsOptions.hasOwnProperty("sources") &&
        Array.isArray(videoJsOptions.sources) &&
        videoJsOptions.sources.length > 0 &&
        videoJsOptions.sources[0].hasOwnProperty("src") &&
        (
            videoJsOptions.sources[0].src === "" ||
            videoJsOptions.sources[0].src === undefined ||
            videoJsOptions.sources[0].src === null
        )
    )
}

const isValidPosterImage = (videoJsOptions) => {
    return (videoJsOptions.hasOwnProperty("poster") && (videoJsOptions.poster !== "" || videoJsOptions.poster !== undefined || true))
}
const posterImage = (videoJsOptions,onClick) => {
    return (
        <div className="video-detail-poster-container" onClick={onClick}>
            <img
                src={isValidPosterImage(videoJsOptions) ? videoJsOptions.poster : assets.clipstore.home.video_placeholder}
                alt={"video placeholder"}
                style={{width: '100%', height: 400, objectFit: 'cover'}}/>
            <img src={assets.clipstore.home.video_play} alt="play"
                 className="gallery-thumbnail"/>
        </div>
    )
}

const hasTags = (content) => {
    return content.hasOwnProperty("tags") && Array.isArray(content.tags);
}

const retrieveTagsFromGallery = (contentArray) => {
    let tags = [];
    contentArray.map((content, index) => {
        if (hasTags(content)) {
            content.tags.map((tag) => {
                tags.push(tag)
            })
        }
    });

    return tags;
}
const getTags = (content) => {
    if (content) {
        const isVideoOrPictureContent = hasTags(content);
        if (isVideoOrPictureContent) {
            //this is a video or picture content
            return content.tags;
        } else {
            const isVideoGalleryContent = content.hasOwnProperty("videos") && Array.isArray(content.videos) && content.videos.length > 0;
            const isPictureGalleryContent = content.hasOwnProperty("pictures") && Array.isArray(content.pictures) && content.pictures.length > 0;
            if (isVideoGalleryContent) {
                return retrieveTagsFromGallery(content.videos);
            } else if (isPictureGalleryContent) {
                return retrieveTagsFromGallery(content.pictures);
            }
        }
    }

    return [];
}

const hasContent = (props) => {
    return props.location &&
        props.location.hasOwnProperty("state") &&
        props.location.state &&
        props.location.state.hasOwnProperty("content") &&
        props.location.state.content &&
        props.location.state.content.hasOwnProperty("id");
}

const getContent = (props, key1) => {
    const content = props.location &&
        props.location.hasOwnProperty("state") &&
        props.location.state &&
        props.location.state.hasOwnProperty("content") &&
        props.location.state.content;

    if (key1) {
        return content[key1];
    }

    return content;
}

export default {
    isVideoURLPresent,
    posterImage,
    getTags,
    hasContent,
    getContent
}